import { ExamSubjectType, QuestionType, ThinkingLevel } from './enum';

export const questionTypes = [
  {
    key: QuestionType.GROUPED_QUESTION,
    value: 'Chùm câu hỏi',
  },
  {
    key: QuestionType.ONE_CHOICE_QUESTION,
    value: 'Chỉ có một câu trả lời đúng',
  },
  {
    key: QuestionType.SHORT_QUESTION,
    value: 'Câu hỏi dạng trả lời ngắn',
  },
  {
    key: QuestionType.YES_NO_QUESTION,
    value: 'Câu trả lời đúng sai',
  },
  {
    key: QuestionType.TOPIC_QUESTION,
    value: 'Câu hỏi tự luận',
  },
];

export const thinkingLevels = [
  {
    code: 'M1',
    key: ThinkingLevel.KNOWING,
    value: 'Nhận biết',
  },
  {
    code: 'M2',
    key: ThinkingLevel.UNDERSTANDING,
    value: 'Thông hiểu',
  },
  {
    code: 'M3',
    key: ThinkingLevel.APPLYING,
    value: 'Vận dụng',
  },
  {
    code: 'M4',
    key: ThinkingLevel.HIGHLY_APPLYING,
    value: 'Vận dụng cao',
  },
];

export const examSubjectTypes = [
  {
    key: ExamSubjectType.MATH,
    value: 'Toán',
  },
  {
    key: ExamSubjectType.PHYSIC_CHEMISTRY_BIOLOGY_GEOGRAPHY,
    value: 'Lý-Hóa-Sinh-Địa',
  },
  {
    key: ExamSubjectType.HISTORY_EDUCDCATION_AND_LAW,
    value: 'Lịch sử-Giáo dục và pháp luật',
  },
  {
    key: ExamSubjectType.LITERATURE,
    value: 'Ngữ văn',
  },
  {
    key: ExamSubjectType.ENGLISH,
    value: 'Tiếng anh',
  },
];
